/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_Use_TotpInputs */



/**
* | output |
* | --- |
* | "Authenticator app" |
*
* @param {Auth_Reset_Use_TotpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_reset_use_totp = /** @type {((inputs?: Auth_Reset_Use_TotpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_Use_TotpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Authenticator-App")
	return /** @type {LocalizedString} */ ("Authenticator app")
});